if (!customElements.get('countdown-timer')) {
	class Countdown extends HTMLElement {
		constructor() {
			super()
			// New: read the Unix timestamp from Liquid (seconds since epoch)
			this.endTimestamp = parseInt(this.getAttribute('data-end-timestamp'), 10)
			this.interval

			if (!isNaN(this.endTimestamp)) {
				this.setInterval(this.endTimestamp)
			}
		}

		// Change signature to accept the timestamp instead of date/time strings
		onInit(endTimestamp) {
			this.completedCountdown = this.getAttribute('data-completed')
			this.countdown = this.querySelector('.countdown__main')
			this.countdownHeading = this.querySelector('.countdown__end-info')
			this.daysEl = this.querySelector('.countdown_block_days')
			this.hoursEl = this.querySelector('.countdown_block_hours')
			this.minutesEl = this.querySelector('.countdown_block_minutes')
			this.secondsEl = this.querySelector('.countdown_block_seconds')
			this.section = this.closest('.countdown-section')

			// ----------------------------------------------------------------
			// New: use fixed end timestamp (store timezone) and current time
			const endTimeMs = endTimestamp * 1000
			const nowMs = Date.now()
			const distance = endTimeMs - nowMs // milliseconds until end

			const days = Math.floor(distance / (1000 * 60 * 60 * 24))
			const hours = Math.floor(
				(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			)
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
			const seconds = Math.floor((distance % (1000 * 60)) / 1000)
			// ----------------------------------------------------------------
			if (distance < 0 && this.completedCountdown === 'hide_section') {
				clearInterval(this.interval)
				this.section.style.display = 'none'
			} else if (distance < 0 && this.completedCountdown === 'show_text') {
				this.countdown.style.display = 'none'
				if (this.countdownHeading) {
					this.countdownHeading.style.display = 'flex'
				}
			} else {
				if (String(days).length === 1) this.daysEl.textContent = '0' + days
				else this.daysEl.textContent = days

				if (String(hours).length === 1) this.hoursEl.textContent = '0' + hours
				else this.hoursEl.textContent = hours

				if (String(minutes).length === 1)
					this.minutesEl.textContent = '0' + minutes
				else this.minutesEl.textContent = minutes

				if (String(seconds).length === 1)
					this.secondsEl.textContent = '0' + seconds
				else this.secondsEl.textContent = seconds
			}
		}

		// Also update setInterval to use the timestamp
		setInterval(endTimestamp) {
			clearInterval(this.interval)
			this.interval = setInterval(
				this.onInit.bind(this, endTimestamp),
				1000
			)
		}
	}

	customElements.define('countdown-timer', Countdown)
}
